import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";
const urlApi = process.env.REACT_APP_API_KEY

export const INITIAL_VEHICLES = {
    "ID": null,
    "DESCRIPCION": "",
    "MARCA": null,
    "NUMERO_SERIE": "",
    "PLACAS": "",
    "FOTOGRAFIA": "",
    "FOTO": "",
    "CHOFER": "",
    "GPS": "",
    "TICKETCARD_NUMERO": "",
    "ID_CLIENTE": null,
    "FECHA_ALTA": "",
    "TIPO": null,
    "MODELO": "",
    "NUMERO_MOTOR": "",
    "PLACAS_FEDERALES": "",
    "LOCATOR": "",
    "TICKETCARD_NIP": "",
    "ID_CLIENTE_COMBINA_1": null,
    "ACTIVA": true,
    "FECHA_BAJA": "",
    "MARCA_UNIDAD": null,
    "ESTATUS": 1,
    "PASAJEROS": 0,
    "COLOR": 1,
    "RENDIMIENTO": null,
    "TARJETA_IAVE": "",
    "ID_CLIENTE_COMBINA_2": null,
    "NOMBRE": null,
    "INICIO_CREDITO": "",
    "PLAZO": null,
    "FIN_CREDITO": "",
    "VALOR_UNIDAD": 0,
    "ASEGURADORA": null,
    "POLIZA_NUMERO": "",
    "POLIZA_VIGENCIA": "",
    "POLIZA_COSTO": 0,
    "POLIZA_TEL_SINIESTROS": "",
    "VINIL": null,
    "COMBUSTIBLE_TRAMPA": null,
    "ACREEDOR": null,
    "KILOMETROS_SERVICIO": null,
    "LITROS_ACEITE": null,
    "INVENTARIO": null,
    "TIPO_ACEITE": "",
    "TIPO_LLANTA": "",
    "LITROS_COMBUSTIBLE": null,
    "LETRERO": null,
    "ICONO": "",
    "SIGUIENTE_SERVICIO": null,
    "ITEM_ID_WIALON": null,
    "IE_TV": null,
    "IE_AFORO": false,
    "IE_CAMARAS": false,
    "IE_AIRE": false,
    "IE_USB": false,
    "IE_CAJUELA": false,
    "IE_PORTABULTOS": false,
    "IE_GPS": true,
    "IE_DVR_CAMARA_CANT": null,
    "IE_DVR_MODELO": null,
    "IE_DVR_CAPACIDAD": null,
    "REQ_TV": false,
    "REQ_DVR": false,
    "ID_EQUIPOS_MOVILES_MAC": null,
    "BTN_PANICO": false,
    "CAMARA_REVERSA": false,
    "ASIENTO_RECLINA": false,
    "CAMARA_FATIGA": false,
    "DESCONECTA_CAMARA": false,
    "SENSOR_CAMARA": false
}

export const getDashboardData = async (unit) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getUnitCatalogById?unit=${unit}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getOptionsParallel = async () => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getOptionsParallel`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getUnitFile = async (unit) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getUnitFile?unit=${unit}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const openFile = async (unit, file ) => {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${urlApi}/maintenance/openFile?unit=${unit}&file=${file}`, {
        headers: { Authorization: token },
    });

    if (!res.ok) {
        alert("No tienes permiso o el archivo no existe");
        return;
    }

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
}

export const getMaintenanceKardex = async (unit) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getMaintenanceKardex?unit=${unit}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getMaintenanceKardexByType = async (unit, service) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getMaintenanceKardexByType?unit=${unit}&service=${service}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getMaintenanceServiceByType = async (service) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getMaintenanceServiceByType?service=${service}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getUnitMaintenanceData = async (unit ) => {
    try {

        const result = await api.get(`${urlApi}/maintenance/getUnitMaintenanceData?unit=${unit}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const updateUnitCatalog = async (unit) => {
    try {

        const result = await api.post(`${urlApi}/maintenance/updateUnitCatalog`, unit);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const addUnitCatalog = async (unit) => {
    try {

        const result = await api.post(`${urlApi}/maintenance/addUnitCatalog`, unit);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const uploadImage = async (formData) => {
    try {
        const res = await api.post(`${urlApi}/maintenance/uploadImage`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
        await Swal.fire('Éxito', 'Archivo subido correctamente', 'success');
        return res.data
    } catch (error) {
        console.error("Error al subir archivo", error);
    }
};

export const addUnitFile = async (data) => {
  try {
      const result = await api.post(`${urlApi}/maintenance/addUnitFile`, data);
      return result.data;
  } catch (error) {
      console.log("error", error);
  }
}

export const getUnitCatalog = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/getUnitCatalog`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}
